<section hlmCard class="login-card">
  <div hlmCardContent class="login-card__card-content">
    <div class="login-card__content">
      <div class="login-card__header-row">
        <span class="login-card__badge">EARLY ACCESS</span>
      </div>
      <h2 class="login-card__subtitle">Welcome to Open Collaboration Platform!</h2>
      <h1 class="login-card__title">Create your account</h1>
    </div>

    <div class="login-card__body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <label class="login-card__label" for="email">Email</label>
        <div class="login-card__input-with-icon">
          <input
            id="email"
            type="email"
            formControlName="email"
            placeholder="Email"
            class="login-card__input login-card__input--wide login-card__input--email"
          />
          @if (f['email'].touched && !f['email'].invalid) {
            <ocp-themed-icon
              name="checkmark-green.svg"
              class="login-card__valid-icon"
              [size]="18"
            />
          }
        </div>
        @if (f['email'].touched && f['email'].invalid) {
          <div class="login-card__error">
            @if (f['email'].errors?.['required']) {
              <span>Invalid email address</span>
            }
            @if (f['email'].errors?.['email']) {
              <span>Invalid email address</span>
            }
          </div>
        }

        <div class="login-card__row">
          <div class="login-card__col">
            <label class="login-card__label" for="firstName">First name</label>
            <input
              id="firstName"
              formControlName="firstName"
              placeholder="First name"
              class="login-card__input login-card__input--short"
            />
            @if (f['firstName'].touched && f['firstName'].invalid) {
              <div class="login-card__error">First name is required</div>
            }
          </div>
          <div class="login-card__col">
            <label class="login-card__label" for="lastName">Last name</label>
            <input
              id="lastName"
              formControlName="lastName"
              placeholder="Last name"
              class="login-card__input login-card__input--short"
            />
            @if (f['lastName'].touched && f['lastName'].invalid) {
              <div class="login-card__error">Last name is required</div>
            }
          </div>
        </div>

        <label class="login-card__label" for="password">Password</label>
        <div class="login-card__input-with-icon">
          <input
            id="password"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            placeholder="Password"
            class="login-card__input login-card__input--wide"
          />
          <ocp-themed-icon
            name="eye.svg"
            class="login-card__eye"
            [size]="18"
            role="button"
            tabindex="0"
            (click)="toggleShowPassword()"
            (keydown.enter)="toggleShowPassword()"
            (keydown.space)="$event.preventDefault(); toggleShowPassword()"
          />
          @if (f['password'].touched && !f['password'].invalid) {
            <ocp-themed-icon
              name="checkmark-green.svg"
              class="login-card__valid-icon"
              [size]="18"
            />
          }
        </div>
        @if (f['password'].touched && f['password'].invalid) {
          <div class="login-card__error">
            @if (f['password'].errors?.['required']) {
              <span>Password is required</span>
            }
            @if (f['password'].errors?.['minlength']) {
              <span>Min allowed characters count is 8.</span>
            }
          </div>
        }

        <label class="login-card__label" for="confirmPassword">Confirm password</label>
        <div class="login-card__input-with-icon">
          <input
            id="confirmPassword"
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirmPassword"
            placeholder="Confirm password"
            class="login-card__input login-card__input--wide"
          />
          @if (
            (f['confirmPassword'].touched || form.touched) &&
            !form.errors?.['passwordsMismatch'] &&
            !f['confirmPassword'].invalid
          ) {
            <ocp-themed-icon
              name="checkmark-green.svg"
              class="login-card__valid-icon"
              [size]="18"
            />
          }
        </div>
        @if (f['confirmPassword'].touched && f['confirmPassword'].errors?.['required']) {
          <div class="login-card__error">Confirm password is required</div>
        }
        @if ((f['confirmPassword'].touched || form.touched) && form.errors?.['passwordsMismatch']) {
          <div class="login-card__error">Password isn't matching</div>
        }

        <label class="login-card__label" for="country">Country</label>
        <hlm-select
          [value]="f['country'].value"
          (valueChange)="onCountryChange($event)"
          class="login-card__country-select"
        >
          <hlm-select-trigger buttonId="country" class="w-full">
            <hlm-select-value placeholder="Select country..." />
          </hlm-select-trigger>
          <hlm-select-content *hlmSelectPortal class="max-h-60">
            @for (option of countryOptions; track option.value) {
              <hlm-select-item [value]="option.value">{{ option.label }}</hlm-select-item>
            }
          </hlm-select-content>
        </hlm-select>
        @if (f['country'].touched && f['country'].invalid) {
          <div class="login-card__error">Country is required</div>
        }

        <div class="login-card__checkbox">
          <input
            type="checkbox"
            id="legal"
            formControlName="legal"
            aria-label="Accept legal documents"
            aria-describedby="legal-description"
          />
          <div
            id="legal-description"
            class="login-card__checkbox-text"
            [innerHTML]="legalTextHtml"
          ></div>
        </div>
        @if (f['legal'].touched && f['legal'].invalid) {
          <div class="login-card__error">You must accept the legal documents</div>
        }

        <div class="login-card__actions">
          <button hlmBtn type="submit" class="login-card__button" [disabled]="form.invalid">
            Create account
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
